<div  
  id="container" 
  class="engine"
  data-test="engine"
  [attr.data-progress]="progress"
  role="complementary"
  #engine>
  <canvas id="theCanvas" data-test="engineCanvas" class="engine__canvas" #engineCanvas></canvas>
  <canvas id="annotationCanvas" class="engine__annotations" #engineAnnotations></canvas>  
  <app-labels></app-labels>

  <app-engine-contextmenu
    [node]="contextmenuNode"
    [hit]="contextmenuHit"
    *ngIf="contextmenuNode">
  </app-engine-contextmenu>

  <!-- input blocking -->
  <div *ngIf="!inputEnabled" data-test="engineInputBlocker" class="engine__input-blocking"></div>
  
  <app-engine-progress data-test="engineProgressBar" *ngIf="showProgressBar$ | async"></app-engine-progress>

  <app-engine-scroll></app-engine-scroll>

  <app-engine-fade></app-engine-fade>

  <ng-container *appFlagApplication="application.Loft;">
    <app-engine-camera-position></app-engine-camera-position>
  </ng-container>
</div>